// gift with purchase script to work with rebuy

let include_tags = Shopify.theme_settings.free_gift_include_tag_handle_list, // cart price to include tags
  exclude_collection = Shopify.theme_settings.free_gift_exclude_collection, // cart price to exclude collection
  freeGifts = []; // array of free gifts settings

// free gift with purchase functionality
const giftWithPurchaseInit = () => {
  if (Shopify.theme_settings.enable_free_gift != true) {
    return;
  }
  if (Object.keys(freeGifts).length == 0) {
    return;
  }

  $.getJSON("/cart.js", function (cart) {
    let cartItems = cart.items,
      cartTotal = include_tags.length == 0 ? cart.total_price : 0; // if using include_tags, use total of tagged product prices

    if (Shopify.theme_settings.enable_buy_x_from_collection_get_y) {
      collectionBuyXFromCollectionGetYInit(cartItems);
    }
    
    // get cart total if include_tags exists
    if (include_tags.length != 0) {
      for (let i = 0; i < cartItems.length; i++) {
        let isFreeGift = freeGifts.some(
          (freeGift) => freeGift.id === cartItems[i].variant_id.toString(),
        );
        if (!isFreeGift && include_tags.includes(cartItems[i].handle)) {
          cartTotal += cartItems[i].final_line_price;
        }
      }
    }

    // exclude collection items for free gwp
    for (var i = 0; i < exclude_collection.length; i++) {
      for (var j = 0; j < cartItems.length; j++) {
        if (exclude_collection[i] == cartItems[j].id) {
          cartTotal = cartTotal - cartItems[j].final_line_price;
        }
      }
    }

    updateCartWithFreeGift(cartItems, cartTotal);
  });
};

// cart free gifts logic
const updateCartWithFreeGift = (cartItems, cartTotal) => {
  let cartUpdates = {};
  freeGifts.forEach((freeGift) => {
    // check if free gift is in cart
    let freeGiftPresent = cartItems.some(
      (item) => item.variant_id.toString() === freeGift.id,
    );

    if (cartTotal > freeGift.threshold) {
      if (!freeGiftPresent) {
        // add free gift to cart if over threshold
        cartUpdates[freeGift.id] = 1;
      } else {
        // set free gift quantity to 1 if over 1
        cartItems.forEach((item) => {
          if (item.variant_id.toString() === freeGift.id && item.quantity > 1) {
            cartUpdates[freeGift.id] = 1;
          }
        });
      }
    } else {
      if (freeGiftPresent) {
        // remove free gift from cart if under threshold
        cartUpdates[freeGift.id] = 0;
      }
    }
  });

  if (Object.keys(cartUpdates).length > 0) {
    updateCart(cartUpdates);
  }
};

const updateCart = (cartUpdates) => {
  $.post("/cart/update.js", {
    updates: cartUpdates,
  });
};

// original buy x from collection get y logic
const collectionBuyXFromCollectionGetYInit = (cartItems) => {
  let collectionBuyXFromCollectionGetY =
      Shopify.theme_settings.buy_x_from_collection_get_y__collection,
    collectionProductsInCart = []; //used to see the collection products in cart

  for (var i = 0; i < collectionBuyXFromCollectionGetY.length; i++) {
    for (var j = 0; j < cartItems.length; j++) {
      if (collectionBuyXFromCollectionGetY[i] == cartItems[j].id) {
        if (cartItems[j].quantity > 1) {
          for (var k = 0; k < cartItems[j].quantity; k++) {
            collectionProductsInCart.push(collectionBuyXFromCollectionGetY[i]);
          }
        } else {
          collectionProductsInCart.push(collectionBuyXFromCollectionGetY[i]);
        }
      }
    }
  }
  if (
    collectionProductsInCart.length ==
    Shopify.theme_settings.buy_x_from_collection_get_y__number_of_products
  ) {
    cartUpdates = {
      [Shopify.theme_settings.buy_x_from_collection_get_y__free_gift_id]: 1,
    };

    if (Object.keys(cartUpdates).length > 0) {
      updateCart(cartUpdates);
    }
  }
};

// initialise free gift settings into array
const initialiseFreeGifts = () => {
  if (Shopify.theme_settings.free_gift_id !== "") {
    freeGifts.push({
      id: Shopify.theme_settings.free_gift_id,
      threshold: Number(Shopify.theme_settings.total_threshold),
    });
  }
  if (Shopify.theme_settings.free_gift_id_2 !== "") {
    freeGifts.push({
      id: Shopify.theme_settings.free_gift_id_2,
      threshold: Number(Shopify.theme_settings.total_threshold_2),
    });
  }
  if (Shopify.theme_settings.free_gift_id_3 !== "") {
    freeGifts.push({
      id: Shopify.theme_settings.free_gift_id_3,
      threshold: Number(Shopify.theme_settings.total_threshold_3),
    });
  }
};

document.addEventListener("rebuy:smartcart.ready", () => {
  initialiseFreeGifts();
});

document.addEventListener("rebuy:cart.change", () => {
  giftWithPurchaseInit();
});